import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState, MarketplaceDataState } from "./marketplace.state";
import { MarketplaceAddon, Partnership } from "../entities/marketplace.entities";

export const MarketplaceSlice = createSlice({
  name: "marketplace",
  initialState,
  reducers: {
    setGroupedData: (
      state,
      action: PayloadAction<Omit<MarketplaceDataState, "selectedAddon">>
    ) => {
      state.data = { ...state.data, ...action.payload };
    },
    setAddons: (state, action: PayloadAction<MarketplaceAddon[]>) => {
      state.data.addons = action.payload;
    },
    setPartners: (state, action: PayloadAction<Partnership[]>) => {
      state.data.partners = action.payload;
    },
    setSelectedAddon: (
      state,
      action: PayloadAction<MarketplaceAddon | undefined>
    ) => {
      state.data.selectedAddon = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.ui.loading = action.payload;
    },
    setLoadingDetail: (state, action: PayloadAction<boolean>) => {
      state.ui.loadingDetail = action.payload;
    },
    resetMarketplace: (state) => {
      state.data = initialState.data;
      state.ui = initialState.ui;
    },
  },
});

export const marketplaceActions = MarketplaceSlice.actions;
export const marketplaceReducer = MarketplaceSlice.reducer;
